export type State = {
  clickTimeout: NodeJS.Timeout | null;
  lastClickTarget: HTMLDivElement | null;
};

export const state: State = {
  clickTimeout: null,
  lastClickTarget: null,
};
